
import React, { useState, useEffect } from 'react';

const Whack: React.FC = () => {
  const [moles, setMoles] = useState(Array(9).fill(false));
  const [score, setScore] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      const idx = Math.floor(Math.random() * 9);
      const newMoles = Array(9).fill(false);
      newMoles[idx] = true;
      setMoles(newMoles);
    }, 800);
    return () => clearInterval(timer);
  }, []);

  const whack = (idx: number) => {
    if (moles[idx]) {
      setScore(s => s + 1);
      const newMoles = [...moles];
      newMoles[idx] = false;
      setMoles(newMoles);
    }
  };

  return (
    <div className="flex flex-col items-center">
      <div className="mb-8 text-2xl font-black text-red-500">BUGS PATCHED: {score}</div>
      <div className="grid grid-cols-3 gap-4">
        {moles.map((m, i) => (
          <button
            key={i}
            onClick={() => whack(i)}
            className={`w-24 h-24 rounded-full border-b-8 transition-all ${
              m ? 'bg-red-500 border-red-700 -translate-y-2' : 'bg-slate-800 border-slate-900 translate-y-0'
            } flex items-center justify-center text-4xl`}
          >
            {m ? '🐛' : ''}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Whack;
